import { YStack, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

type CircularProgressProps = {
  value: number;
  label: string;
  progressColor?: string;
};

export const CircularProgress = ({ value, label, progressColor }: CircularProgressProps) => {
  const size = 220;
  const baseStrokeWidth = 4;
  const progressStrokeWidth = 8;
  const radius = (size - progressStrokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - value / 100);

  const backgroundStroke = tokens.color.transparentBorder;

  const circleId = Math.random();

  return (
    <YStack height={400} alignItems="center">
      <svg width={size} height={size} viewBox={`-10 -10 ${size + 20} ${size + 20}`}>
        <defs>
          <filter id={`blur-shadow-${circleId}`} x="-50%" y="-50%" width="200%" height="200%">
            <feDropShadow
              dx="0"
              dy="0"
              stdDeviation="6"
              floodColor={progressColor}
              floodOpacity="0.5"
            />
          </filter>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={backgroundStroke}
          strokeWidth={baseStrokeWidth}
          fill="none"
        />

        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={progressColor}
          strokeWidth={progressStrokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          fill="none"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          filter={`url(#blur-shadow-${circleId})`}
        />
      </svg>

      <YStack
        position="absolute"
        top={size / 2 - 36}
        left={0}
        right={0}
        alignItems="center"
        justifyContent="center">
        <Text fontFamily="$heading" fontWeight="$9.5" fontSize="$9.5" color={progressColor}>
          {value}%
        </Text>
      </YStack>

      <Text fontSize="$9.5" color={tokens.color.white12} marginTop="$5" textAlign="center">
        {label}
      </Text>
    </YStack>
  );
};
